<div class="modal-body mega-campaign-modal p-0">
   <article class="mega-campaign position-relative">
      <button type="button" class="btn-close close-btn" aria-label="Close"
         (click)="closeMegaLaunchCampaignModal()"></button>

      <h2 class="headline text-center mb-3">First <span class="accent">{{ totalInvestorsTarget }} investors</span>
         receive up to <br /><span class="accent">19% Bonus</span> shares of Musaffa!</h2>
      <p class="text-center body-1 mb-3">Includes an <strong><span class="accent" style="font-weight: 800;">extra
               10%</span></strong> for Mega Campaign!</p>

      <div class="timer-wrapper text-center mb-4">
         <p class="timer-label mb-3">MEGA LAUNCH CAMPAIGN BONUS SHARES DEADLINE</p>
         <div class="timer d-flex justify-content-center align-items-center gap-3">
            <div class="time-box">
               <div class="time-value" *ngIf="!countdownLoading; else daySkel">{{ pad2(daysLeft) }}</div>
               <ng-template #daySkel>
                  <div class="time-skeleton"></div>
               </ng-template>
               <div class="time-unit">DAY</div>
            </div>
            <div class="time-sep"></div>
            <div class="time-box">
               <div class="time-value" *ngIf="!countdownLoading; else hourSkel">{{ pad2(hoursLeft) }}</div>
               <ng-template #hourSkel>
                  <div class="time-skeleton"></div>
               </ng-template>
               <div class="time-unit">HOUR</div>
            </div>
            <div class="time-sep"></div>
            <div class="time-box">
               <div class="time-value" *ngIf="!countdownLoading; else minuteSkel">{{ pad2(minutesLeft) }}</div>
               <ng-template #minuteSkel>
                  <div class="time-skeleton"></div>
               </ng-template>
               <div class="time-unit">MIN</div>
            </div>
            <div class="time-sep"></div>
            <div class="time-box">
               <div class="time-value" *ngIf="!countdownLoading; else secondSkel">{{ pad2(secondsLeft) }}</div>
               <ng-template #secondSkel>
                  <div class="time-skeleton"></div>
               </ng-template>
               <div class="time-unit">SEC</div>
            </div>
         </div>
      </div>

      <div class="mb-3 laptop-gutters" *ngIf="displayInvestNowButton">
         <p class="mb-2 fw-600 hurry-text">HURRY, OFFER ENDS SOON!</p>
         <div class="progress-wrapper d-flex align-items-center">
            <div class="progress-inner" [style.width.%]="progressPercent"></div>
         </div>
         <p class="mt-2 mb-0 fw-600 left-count-text">{{ remainingInvestors }} left out of {{ totalInvestorsTarget }}</p>
      </div>

      <button *ngIf="displayInvestNowButton" class="btn cta-btn text-white py-3 rounded-3 mb-3 laptop-gutters btn_laptop_gutters"
         (click)="openInvestNowLink()">
         INVEST HALAL NOW
      </button>
   </article>
</div>